import { combineReducers } from "redux";
export function combineDucks(ducksConfig) {
    const actions = Object.keys(ducksConfig).reduce((accumulator, currentKey) => {
        const duck = ducksConfig[currentKey];
        return Object.assign(Object.assign({}, accumulator), { [currentKey]: duck.actions });
    }, {});
    const middleware = Object.keys(ducksConfig).reduce((accumulator, currentKey) => {
        const duck = ducksConfig[currentKey];
        return [...accumulator, ...duck.middleware];
    }, []);
    const reducersFromDucks = Object.keys(ducksConfig).reduce((accumulator, currentKey) => {
        const duck = ducksConfig[currentKey];
        return Object.assign(Object.assign({}, accumulator), { [currentKey]: duck.reducer });
    }, {});
    const reducer = combineReducers(reducersFromDucks);
    const selectorsFromDucks = Object.keys(ducksConfig).reduce((accumulator, currentKey) => {
        const duck = ducksConfig[currentKey];
        return Object.assign(Object.assign({}, accumulator), { [currentKey]: duck.selectors });
    }, {});
    const selectors = combineSelectors(selectorsFromDucks);
    return { actions, reducer, selectors, middleware };
}
function combineSelectors(keyedSelectors) {
    function wrapSelector(key, selector) {
        return function (state, ...args) {
            return selector(state[key], ...args);
        };
    }
    const wrappedSelectors = Object.keys(keyedSelectors).reduce((accumulator, currentKey) => {
        const selectors = keyedSelectors[currentKey];
        const wrappedSelectorForDuck = Object.keys(selectors).reduce((accumulated, selectorKey) => (Object.assign(Object.assign({}, accumulated), { [selectorKey]: wrapSelector(currentKey, selectors[selectorKey]) })), {});
        return Object.assign(Object.assign({}, accumulator), { [currentKey]: wrappedSelectorForDuck });
    }, {});
    return wrappedSelectors;
}
//# sourceMappingURL=combineDucks.js.map